module.exports = __webpack_public_path__ + "static/media/main3.44d34870.jpg";